import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { noOfRowsInEachGrid } from '../../../brands/default/config';
import { NAVIGATION_LAYOUT } from '../../../brands/default/constants';
import { hashCode } from '../../../helpers/hash';
import ThemeContext from '../../../providers/ThemeProvider';
import CategoryItem from './CategoryItem';
import HeaderNavigationDealCard from './DealCard';

const splitCategoryItems = (items, partsArray) => {
  if (
    !Array.isArray(items) ||
    items.length === 0 ||
    !Array.isArray(partsArray) ||
    partsArray.length === 0
  ) {
    return [];
  }

  const result = [];
  let currentIndex = 0;
  partsArray.forEach((partSize) => {
    const endIndex = Math.min(currentIndex + partSize, items.length);
    result.push(items.slice(currentIndex, endIndex));
    currentIndex = endIndex;
  });

  return result;
};

const GroupedHeaderNavigationPopover = ({ category, deals, site, navCat }) => {
  const theme = useContext(ThemeContext);
  const fourGridEnable = NAVIGATION_LAYOUT.fourGridNav.includes(navCat);
  let groupHeaderRedirectUrl = [];
  const navigationGroups = category?.subNavigations.reduce(
    (accumulator, navigationItem) => {
      const { navigationType, linkText } = navigationItem;
      if (navigationType === linkText) {
        groupHeaderRedirectUrl = [
          ...groupHeaderRedirectUrl,
          { [navigationType]: navigationItem.url },
        ];
        accumulator[navigationType] = accumulator[navigationType] || [];
      }
      if (navigationType && navigationType !== linkText) {
        accumulator[navigationType] = accumulator[navigationType] || [];
        accumulator[navigationType].push(navigationItem);
      }

      return accumulator;
    },
    {},
  );

  const splitCategoryItemsByParts = splitCategoryItems(
    Object.entries(navigationGroups).map(
      ([navigationType, navigations], index, array) => (
        <div key={navigationType}>
          <CategoryItem
            categoryArray={navigations}
            categoryLink={groupHeaderRedirectUrl}
            categoryName={navigationType}
          />
          {Boolean(navigations.length) ||
          (index < array.length - 1 && array[index + 1][1].length > 0) ? (
            <br />
          ) : null}
        </div>
      ),
    ),
    noOfRowsInEachGrid(navCat),
  );

  return (
    <div className="navigation-popover">
      {splitCategoryItemsByParts.map((part, index) => (
        <div className="navigation-popover__column" key={index}>
          {part}
        </div>
      ))}
      {!fourGridEnable && (
        <div className="navigation-popover__column navigation-popover__deals">
          {deals?.map((deal) => (
            <div
              className="navigation-popover__inner"
              key={`HNP_dealcard_${deal.id}_${hashCode()}`}
            >
              <HeaderNavigationDealCard deal={deal} site={site} />
            </div>
          ))}
          {!deals &&
            [null, null, null, null].map((_, index) => (
              <div
                className="deal-card--placeholder"
                key={`HNP_deal_card_${index}_${hashCode()}`}
              />
            ))}
        </div>
      )}
      <style jsx>{`
        .navigation-popover__column {
          padding: 0 15px;
          border-right: 1px solid #cccccc;
          flex-grow: 1;
          flex-basis: 0;
        }
        .navigation-popover__list {
          list-style: none;
          padding: 0;
        }
        .navigation-popover__column:first-child {
          padding-left: 0;
        }
        .navigation-popover__column:last-child {
          border-right: none;
          padding-right: 0;
        }
        .navigation-popover__link {
          color: #000000;
        }
        .navigation-popover__link--small-only {
          display: none;
        }
        .navigation-popover__link:hover {
          color: ${theme.colors.navlinkactive};
        }
        .navigation-popover__deals {
          align-item: top;
          display: flex;
          flex-wrap: wrap;
          min-width: 600px;
          padding: 0 8px;
          margin-top: -15px;
          width: 600px;
          height: 410px;
        }
        .navigation-popover__inner {
          display: flex;
          padding: 15px 7px 0;
          width: 50%;
          max-height: 189px;
        }
        .deal-card--placeholder {
          align-item: top;
          display: flex;
          flex-wrap: wrap;
          padding: 0 8px;
          margin-top: 15px;
          width: 284px;
          height: 188px;
          background-color: #eeeeee;
          margin: 6px;
        }
        .forth-grid {
          padding-top: 15px;
        }

        @media (max-width: ${theme.breakpoints.lgDown}) {
          .navigation-popover__deals {
            width: 525px;
            min-width: 525px;
          }
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .navigation-popover {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

GroupedHeaderNavigationPopover.propTypes = {
  category: PropTypes.object,
  deals: PropTypes.array,
  navCat: PropTypes.string,
  site: PropTypes.string,
};

export default GroupedHeaderNavigationPopover;
